module.exports = intersectNode;

function intersectNode(node, point) {
  return node.intersect(point);
}
